export const ru = {
    'predictor-error': 'Прогноз временно недоступен',
    'reach-title': 'Прогноз охвата за 7 дней'
};
